var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "payment", title: "Payment" } },
    [
      _vm._v("\n  The\n  "),
      _c("em", [_vm._v("Customer")]),
      _vm._v("\n  agrees to pay the license fee for\n  "),
      _c("em", [_vm._v("Font Awesome Pro")]),
      _vm._v("\n  specified via the\n  "),
      _c("em", [_vm._v("Web Store")]),
      _vm._v("\n  at the time\n  "),
      _c("em", [_vm._v("Customer")]),
      _vm._v(
        "\n  entered this agreement, using a payment method accepted by the\n  "
      ),
      _c("em", [_vm._v("Web Store")]),
      _vm._v("\n  .\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }